<div class="mt-5" *ngIf="!isCB">
  <app-commande-header [currentEtape]="currentEtape"></app-commande-header>
</div>

<div class="mt-5">
  <app-choix-pack
    *ngIf="currentEtape === etapeCommandeEnum.MA_COMMANDE"
    [packs]="packs"
    [commande]="commande"
    [isCB]="isCB"
    [isAutoliquidation]="isAutoliquidation"
    (packSelected)="onPackSelected($event)"
    (renouvellementAutoSet)="onRenouvellementAutoSet($event)"
    (commander)="onCommander()"
    (payer)="onPayer()"
  ></app-choix-pack>

  <app-informations-administratives
    *ngIf="currentEtape === etapeCommandeEnum.MES_INFORMATIONS_ADMINISTRATIVES"
    [commande]="commande"
    [loading]="loading"
    (precedent)="onPrecedent()"
    (validerCommande)="onValiderCommande()"
  ></app-informations-administratives>

  <app-commande-validation
    *ngIf="currentEtape === etapeCommandeEnum.MA_VALIDATION"
    [commande]="commande"
  ></app-commande-validation>
</div>
